import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Grid, Typography } from "@material-ui/core";
import clsx from "clsx";
import { answerStyles } from "./answer.styles";

export const Answer = React.memo((props) => {
  const {
    answer,
    onClick: handleClick,
    isAnswerSelected,
    renderImage,
    answerClass,
  } = props;
  const [selected, setSelected] = useState(isAnswerSelected);
  const classes = answerStyles();

  useEffect(() => {
    if (selected !== isAnswerSelected) {
      setSelected(isAnswerSelected);
    }
  }, [isAnswerSelected, selected]);

  const onClick = () => {
    let isSelected = !selected;

    if (answer.disabledSelection) {
      isSelected = false;
    }

    setSelected(isSelected);
    handleClick?.(answer);
  };

  return (
    <Grid container item md={2} sm={4} xs={6}>
      <Button
        className={clsx({
          [classes.answer]: true,
          [classes.selected]: selected,
          [classes.unselected]: !selected,
          [answerClass]: answerClass,
        })}
        fullWidth
        onClick={onClick}
        disabled={!isAnswerSelected && answer.disabledSelection}
      >
        {renderImage ? (
          <>
            <Typography component="div" className="answerDescription">
              {answer.text}
            </Typography>
            {renderImage?.(answer.order)}
          </>
        ) : (
          <Typography component="div" className="answerDescription">
            {answer.text}
          </Typography>
        )}
      </Button>
    </Grid>
  );
});

Answer.propTypes = {
  answer: PropTypes.PropTypes.shape({
    order: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    disabledSelection: PropTypes.bool.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  isAnswerSelected: PropTypes.bool,
  renderImage: PropTypes.func,
  answerClass: PropTypes.string,
};

Answer.defaultProps = {
  onClick: undefined,
  isAnswerSelected: false,
  renderImage: undefined,
  answerClass: "",
};
